import { Search } from 'lucide-react';
import { StatusFilter, type TemplateListView } from '../types';
import { ActiveFilterChips } from './ActiveFilterChips';
import styles from './templates-toolbar.module.css';
import { StatusFilterMenu } from './StatusFilterMenu';
import { TenantFilterMenu } from './TenantFilterMenu';

export function TemplatesToolbar({
  search,
  setSearch,
  statusFilter,
  setStatusFilter,
  statusCounts,
  selectedTenantIds,
  toggleTenant,
  clearTenants,
  tenantFilterOptions,
  tenantNameById,
  isTenantsLoading,
  hasActiveFilters,
  clearAllFilters,
  filteredCount,
  totalCount,
}: TemplateListView) {
  const resultLabel = `${filteredCount} of ${totalCount} templates`;

  return (
    <div>
      <div className={styles.toolbar}>
        <div className={styles.search}>
          <Search className={styles.searchIcon} />
          <input
            type="text"
            className={styles.searchInput}
            placeholder="Search templates by name…"
            value={search}
            onChange={event => setSearch(event.target.value)}
          />
        </div>

        <StatusFilterMenu value={statusFilter} counts={statusCounts} onChange={setStatusFilter} />

        <TenantFilterMenu
          tenantOptions={tenantFilterOptions}
          selectedTenantIds={selectedTenantIds}
          toggleTenant={toggleTenant}
          clearTenants={clearTenants}
          isLoading={isTenantsLoading}
        />

        <span className={styles.resultCount}>{resultLabel}</span>
      </div>

      {hasActiveFilters && (
        <ActiveFilterChips
          statusFilter={statusFilter}
          clearStatus={() => setStatusFilter(StatusFilter.All)}
          selectedTenantIds={selectedTenantIds}
          tenantNameById={tenantNameById}
          removeTenant={toggleTenant}
          clearAll={clearAllFilters}
        />
      )}
    </div>
  );
}
